import { z } from 'zod';
import { GeneratedNodePositionSchema } from '../../entities/process-layout';
import { ObjectIdSchema } from '../../shared/object-id.schema';
/**
 * POST /api/v2/process/:id/draft/steps/:stableStepId/terminal — request
 *
 * Mark a step's task handle, or some of its decision outputs, as ending
 * (`NONE`) or unclear (`UNCLEAR`), and remove what they lead to: downstream
 * steps lose the edge, downstream draft assignments are deleted.
 *
 * No `.refine`/`.superRefine` (bliksy resolveSubSchema); cross-field rules
 * are enforced service-side as 400s:
 * - A decision step needs `ruleIds`, a task step must not have them, and
 *   each id must be one of the step's rules.
 * - Each `endPositions[].nodeId` must be an end node of the marked handle:
 *   `end-<stableStepId>` for the task handle, `end-<stableStepId>-<ruleId>`
 *   with a rule of the marked output groups for a decision.
 */ export const SetDraftStepTerminalRequestSchema = z.object({
    status: z.enum([
        'NONE',
        'UNCLEAR'
    ]),
    /**
   * Absent = the task handle (task steps only). Each id stands for its whole
   * output group (the rules sharing its `output`).
   */ ruleIds: z.array(ObjectIdSchema).min(1).max(100).optional(),
    /**
   * Written to the draft layout under each end node's generated id, one per
   * end marker the request makes appear.
   */ endPositions: z.array(GeneratedNodePositionSchema).min(1).max(100).optional()
});

//# sourceMappingURL=set-draft-step-terminal.schema.js.map